import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { showAlert } from 'mastodon/actions/alerts';
import { copyStatusLink } from 'mastodon/actions/share';
import { Icon } from 'mastodon/components/icon';
import { ContentCopyIcon } from 'mastodon/components/icons/content_copy';
import { ShareIcon } from 'mastodon/components/icons/share';
import { useAppDispatch } from 'mastodon/store';

const messages = defineMessages({
  title: {
    id: 'share_modal.share_to',
    defaultMessage: 'Share to',
  },
  openLaoChat: {
    id: 'share_modal.open_laochat',
    defaultMessage: 'LaoChat',
  },
  copyLink: {
    id: 'share_modal.copy_link',
    defaultMessage: 'Copy link',
  },
  other: {
    id: 'share_modal.other',
    defaultMessage: 'Other',
  },
  whatsapp: {
    id: 'share_modal.whatsapp',
    defaultMessage: 'WhatsApp',
  },
  facebook: {
    id: 'share_modal.facebook',
    defaultMessage: 'Facebook',
  },
  x: {
    id: 'share_modal.x',
    defaultMessage: 'X',
  },
  failed: {
    id: 'share_modal.failed',
    defaultMessage: 'Unable to share',
  },
});

export const ExternalZone = ({ statusUrl }) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const copyLink = useCallback(() => {
    dispatch(copyStatusLink(statusUrl));
  }, [dispatch, statusUrl]);

  const nativeShare = useCallback(() => {
    if (window.LaoApp?.nativeShare) {
      window.LaoApp.nativeShare(statusUrl, document.title);
      return;
    }

    if (navigator.share) {
      navigator.share({ url: statusUrl, title: document.title }).catch(error => {
        if (error.name !== 'AbortError') {
          dispatch(showAlert({ message: messages.failed }));
        }
      });
      return;
    }

    copyLink();
  }, [copyLink, dispatch, statusUrl]);

  return (
    <section className='share-modal__zone'>
      <h2 className='share-modal__zone-title'>{intl.formatMessage(messages.title)}</h2>
      <div className='share-modal__external-list'>
        <button type='button' className='share-modal__external-item' onClick={copyLink}>
          <span className='share-modal__external-icon share-modal__external-icon--copy'>
            <Icon id='copy' icon={ContentCopyIcon} />
          </span>
          <span>{intl.formatMessage(messages.copyLink)}</span>
        </button>

        <button type='button' className='share-modal__external-item' onClick={nativeShare}>
          <span className='share-modal__external-icon share-modal__external-icon--other'>
            <Icon id='share' icon={ShareIcon} />
          </span>
          <span>{intl.formatMessage(messages.other)}</span>
        </button>
      </div>
    </section>
  );
};

ExternalZone.propTypes = {
  statusUrl: PropTypes.string.isRequired,
};
